import React from "react";
import { Trans } from "@bookingcom/lingojs-react";
import useGeniusRewardsInfoController from "./useGeniusRewardsInfo.controller";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { BaggageItem } from "../../../../../../../ancillaries/components/ExtraProducts/components/BaggageItem";
import FlexTicketItem from "../../../../../../../ancillaries/components/ExtraProducts/components/FlexTicketItem";
import { UIFlightData } from "@flights/types";
import FlightDetailsAncillaryItemLayout from "../../../../../FlightDetailsAncillaryItemLayout";
import { DiscountBubbleIcon } from "@bookingcom/bui-assets-react/streamline";
import InGeniusSavingBadge from "./InGeniusSavingBadge";

const useGeniusRewardsInfo = (flight: UIFlightData) => {
  const {
    hasGeniusRewards,
    headerColor,
    subheader,
    checkedBaggageDiscount,
    showCheckedBaggageLoadingPrice,
    flexTicketDiscount,
    flightGeniusDiscount,
    geniusSavingBadgeData
  } = useGeniusRewardsInfoController(flight);

  if (!hasGeniusRewards) return undefined;

  return {
    header: (
      <Trans
        tag="flights_fd_your_genius_rewards_title"
        variables={{
          start_style: "<0>",
          end_styling: "</0>"
        }}
        components={[<b key={0} style={{ color: headerColor }} />]}
      />
    ),
    subheader,
    content: (
      <Stack gap={2}>
        {checkedBaggageDiscount && (
          <BaggageItem
            type="checkedInBaggage"
            product={checkedBaggageDiscount}
            showLoadingPrice={showCheckedBaggageLoadingPrice}
            hasGeniusDeal={true}
          />
        )}
        {flexTicketDiscount && <FlexTicketItem flexibleTicket={flexTicketDiscount} hasGeniusDeal />}
        {flightGeniusDiscount && (
          <FlightDetailsAncillaryItemLayout
            icon={<Icon size="large" svg={DiscountBubbleIcon} />}
            content={
              geniusSavingBadgeData ? (
                <InGeniusSavingBadge {...geniusSavingBadgeData} />
              ) : (
                <Text>{flightGeniusDiscount}</Text>
              )
            }
            includedBaggage
            geniusSavingIncluded
          />
        )}
      </Stack>
    )
  };
};

export default useGeniusRewardsInfo;
